import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SessionService } from 'src/app/services/StoreService/SessionService/session.service';

@Component({
  selector: 'app-internal-header',
  templateUrl: './internal-header.component.html',
  styleUrls: ['./internal-header.component.scss']
})
export class InternalHeaderComponent implements OnInit {

  constructor(
    private router: Router,
    private sessionService: SessionService
  ) { }

  ngOnInit(): void {}

  user = this.sessionService.getUser() || null;
  name = this.user.user.name;
  lastName = this.user.user.lastName;
  //name: null | string = localStorage.getItem("name");
  //lastName: null | string = localStorage.getItem("lastName");

  logOut() {
    this.sessionService.newUser(null);
    localStorage.removeItem("token");
    this.router.navigate(["/pb/log-in"]);
  }

}
